import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="block-dark testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2>Miles de decisiones pequeñas hacen una gran diferencia</h2>
          <p>
            Si no sabes por dónde comenzar, no pasa nada. Para eso estamos: una orientación clara, rápida y accesible.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="#FFC107" stroke="#FFC107" />
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <p className="testimonial-author">— {testimonial.name}</p>
            </div>
          ))}
        </div>

        <div className="why-zenko">
          <h3 className="!text-2xl">¿Por qué ZenKo?</h3>
          <div className="reasons-grid">
            <div className="reason-card">
              <h4>Simple</h4>
              <p>Recomendaciones claras, sin exceso de información.</p>
            </div>
            <div className="reason-card">
              <h4>Atención personalizada</h4>
              <p>Escríbenos cuando lo necesites y te apoyamos.</p>
            </div>
            <div className="reason-card">
              <h4>Accesible y confiable</h4>
              <p>Opciones para diferentes objetivos y presupuestos, con envíos a todo El Salvador.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;